// ความจำต่อแชท (สรุปเรื่องที่ผ่านมา) เก็บใน RTDB: /chat_memory/<chatId> = {summary, facts[], updatedAt, upToMsgId, recent[]}
//  recent = key ของคำตอบ 3 ครั้งล่าสุดที่ตัวละครตอบจากไฟล์ (กันตอบซ้ำ) — เขียนแบบ patch เพื่อไม่ทับ summary และกลับกัน
//  แยกจากโน้ตของผู้ใช้ (/memories) — ใช้จัดบริบทตอบครั้งต่อไป ; สรุปต่อจากของเดิมทุก SUMMARY_EVERY ข้อความ ทำหลังตอบเสร็จ ไม่บล็อกผู้ใช้
import { fb, fk, nowIso, getRow } from "./core";
import { aiGenerate } from "./ai";
import { clipToTokens } from "../ai/context";

export const SUMMARY_EVERY = 8;
export const SUMMARY_MAX_WORDS = 120;
const memPath = (chatId) => `chat_memory/${fk(chatId)}`;

export const getChatMemory = (chatId) => getRow(memPath(chatId));
export const RECENT_KEEP = 3;
/** key คำตอบล่าสุด (ใหม่สุดก่อน) */
export const recentKeys = (mem) => (mem && Array.isArray(mem.recent) ? mem.recent.filter((x) => typeof x === "string").slice(0, RECENT_KEEP) : []);
/** จำคำตอบที่เพิ่งใช้ ; ไม่ throw (ล้มแค่เสี่ยงตอบซ้ำ ไม่กระทบแชท) */
export async function rememberReply(chatId, key, prev) {
  try {
    await fb.patch(memPath(chatId), { recent: [key, ...prev.filter((k) => k !== key)].slice(0, RECENT_KEEP) });
  } catch (e) {
    /* ข้าม */
  }
}

const running = new Set();
let lastJob = Promise.resolve();
/** รอให้งานสรุปที่ค้างอยู่จบ (ใช้ใน test) */
export const flushMemory = () => lastJob;

const unsummarized = (win, mem) => win.filter((m) => m.isDeleted !== true && m.content && m.type !== "system" && (!mem || !mem.upToMsgId || m.id > mem.upToMsgId));

/** สร้างข้อความ summary จาก summary เดิม + ข้อความใหม่ ; คืน string หรือ null ถ้าล้ม */
export async function summarize({ prev, msgs, userName, charName }) {
  const lines = msgs.slice(-14).map((m) => (m.sender === "user" ? userName : charName) + ": " + clipToTokens(String(m.content).replace(/\s+/g, " "), 120));
  const system = `คุณคือผู้ช่วยสรุปบทสนทนาโรลเพลย์ ตอบเป็นภาษาไทย สรุปต่อจากสรุปเดิมให้เหลือรวมไม่เกิน ${SUMMARY_MAX_WORDS} คำ ` +
    "เก็บเฉพาะเหตุการณ์สำคัญ ข้อเท็จจริงเกี่ยวกับผู้ใช้ และความสัมพันธ์ ตอบเฉพาะข้อความสรุป ไม่ต้องมีคำนำ";
  const content = (prev ? "สรุปเดิม: " + prev + "\n\n" : "") + "บทสนทนาใหม่:\n" + lines.join("\n") + "\n\nเขียนสรุปใหม่รวมทั้งหมด:";
  const r = await aiGenerate({ system, messages: [{ role: "user", content }], maxTokens: 260, temperature: 0.3, background: true });
  if (!r.ok || r.mock) return null;
  return r.text.replace(/\s+/g, " ").trim().slice(0, 900) || null;
}

/**
 * ตรวจว่าครบรอบสรุปหรือยัง (ข้อความใหม่ตั้งแต่ upToMsgId >= SUMMARY_EVERY) แล้วสรุปต่อ+บันทึก
 * เรียกหลังตอบเสร็จโดยไม่ await ; ไม่ throw ; คืน promise ของงาน (หรือ null ถ้าไม่ถึงรอบ)
 */
export function scheduleSummary({ chatId, win, userName, charName, mem }) {
  const fresh = unsummarized(win, mem);
  if (fresh.length < SUMMARY_EVERY || running.has(chatId)) return null;
  running.add(chatId);
  const job = (async () => {
    try {
      const text = await summarize({ prev: mem && mem.summary, msgs: fresh, userName, charName });
      if (!text) return;
      await fb.patch(memPath(chatId), { summary: text, facts: (mem && mem.facts) || [], updatedAt: nowIso(), upToMsgId: fresh[fresh.length - 1].id });
    } catch (e) {
      /* สรุปล้มไม่กระทบแชท — รอบหน้าลองใหม่ */
    } finally {
      running.delete(chatId);
    }
  })();
  lastJob = job;
  return job;
}
